import React from "react";
import { RangeSlider as InputSlider } from "@learningblocks/shared-components";
import cname from "../WidgetStyles/style.module.scss";

/**
 * RangeSlider:
 *  - Wrapper of storybook-components/RangeSlider
 *  - To be used in Widgets Content
 */
export function RangeSlider(props) {
  return (
    <InputSlider
      labelledby={props.labelledby}
      min={props.min}
      max={props.max}
      prevAria={props.prevAria}
      nextAria={props.nextAria}
      step={props.step}
      value={props.value}
      scaleInterval={props.scaleInterval}
      inputLabel={props.inputLabel}
      className={cname.input}
      onChange={props.onSliderChange}
      altTextData={props.altTextData}
      ariaInterval={props.ariaInterval}
      keyboardStep={props.keyboardStep}
      ariaLabel={props.ariaLabel}
    />
  );
}
